import { AnalyticsRequest, GroupBy, Metric, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';

export var TemplateBubbleGrid: Panel = {
    id: 'bubble-grid',
    name: 'Bubble Grid',
    description: '',
    tags: ['Standard', 'Bubble Grid', 'Table', 'Heat Map', 'landscape', 'portrait'],
    widget: {
        id: '0',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_bubble_grid',
        children: [
            {
                id: '1',
                name: 'Bubble Grid',
                useGlobalTimePeriod: true,
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 2000,
                        projections: [
                            new Metric({
                                STORY_MESSAGE: { dimensionName: 'NEWS_COUNT', heading: 'Mentions' },
                            }),
                        ],
                        groupBys: [
                            // y = rows
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.day },
                                INBOUND_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'snCTm',
                                },
                                PLATFORM: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                BENCHMARKING: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                PAID: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'measurementTime',
                                },
                                ADVOCACY: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                RDB_FIREHOSE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'SN_CREATED_TIME',
                                },
                                STORY_MESSAGE: {
                                    dimensionName: 'STORY_CATEGORY',
                                    limitType: 'NONE',
                                },
                            }),
                            // x = columns
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.hour },
                                INBOUND_MESSAGE: {
                                    source: ListeningDimensions.hour,
                                    dimensionName: 'snCTm',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                PLATFORM: {
                                    source: ListeningDimensions.hour,
                                    dimensionName: 'date',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                BENCHMARKING: {
                                    source: ListeningDimensions.hour,
                                    dimensionName: 'date',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                PAID: {
                                    source: ListeningDimensions.hour,
                                    dimensionName: 'measurementTime',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                ADVOCACY: {
                                    source: ListeningDimensions.hour,
                                    dimensionName: 'TIME_OF_DAY',
                                    groupType: 'FIELD',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                RDB_FIREHOSE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'SN_CREATED_TIME',
                                    limitType: 'TOP',
                                    limit: 32,
                                },
                                STORY_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'CREATED_TIME',
                                },
                            }),
                            // z = color
                            new GroupBy({
                                LISTENING: {
                                    source: ListeningDimensions.socialNetwork,
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                INBOUND_MESSAGE: {
                                    dimensionName: 'SN_TYPE',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                PLATFORM: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
                                BENCHMARKING: {
                                    dimensionName: 'BENCHMARKING_SN_TYPE',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                PAID: {
                                    dimensionName: 'socialChannelTypes',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                ADVOCACY: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
                                RDB_FIREHOSE: {
                                    dimensionName: 'RDB_QUERY_IDS',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                STORY_MESSAGE: {
                                    dimensionName: 'SENTIMENT',
                                    limitType: 'NONE',
                                },
                            }),
                        ],
                        sorts: [new Sort({ order: 'ASC', groupBys: 1 })],
                        timePeriods: [{ key: 'last_7_days' }],
                    }) as any,
                ],
                position: {
                    width: '100%',
                    height: '100%',
                    top: '0',
                    left: '0',
                },
                label: {
                    titleText: 'Bubble Grid',
                    enabled: true,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    subType: 'orbs',
                    scaleBy: 'set',
                    showSentiment: false,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                        showLegend: false,
                        orbSize: 50,
                    },
                },
                type: 'heatMapTableChart',
            },
        ],
    },
};
